import React, { Component } from 'react';
import dayjs from 'dayjs';

import services from '@C/Reports/_utils/data';
import { TableGrid } from '@C/TableGrid';
import { FuelList, DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';

const col = [
  {
    name: 'Date',
    key: 'date',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Product',
    key: 'product',
  },
  {
    name: 'Quantity',
    key: 'quantity',
  },
  {
    name: 'Margin',
    key: 'margin_value',
  },
  {
    name: 'Profit',
    key: 'profit',
  },
];

class ProfitMargin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      loading: false,
      profitList: [],
      limit: 20,
      offset: 1,
      count: 0,
      product_id: '',
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    // this.getProfitMargin();
  }

  getProfitMargin = () => {
    services
      .getProfitMargin(this.state)
      .then((response) => {
        this.setState({
          profitList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    const maxRangeMonths = 6;

    if (name === 'start_date') {
      const newStartDate = dayjs(value);
      const currentEndDate = dayjs(this.state.end_date);
      const maxEndDate = newStartDate.add(maxRangeMonths, 'month');

      // If new start date is after current end date, set end date to start date
      if (newStartDate.isAfter(currentEndDate)) {
        this.setState({ start_date: value, end_date: value });
      }
      // If end date exceeds 6 months from new start date, adjust end date
      else if (currentEndDate.isAfter(maxEndDate)) {
        this.setState({
          start_date: value,
          end_date: maxEndDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update start date
      else {
        this.setState({ start_date: value });
      }
    } else if (name === 'end_date') {
      const newEndDate = dayjs(value);
      const currentStartDate = dayjs(this.state.start_date);
      const minStartDate = newEndDate.subtract(maxRangeMonths, 'month');

      // If new end date is before current start date, set start date to end date
      if (newEndDate.isBefore(currentStartDate)) {
        this.setState({ end_date: value, start_date: value });
      }
      // If start date is more than 6 months before new end date, adjust start date
      else if (currentStartDate.isBefore(minStartDate)) {
        this.setState({
          end_date: value,
          start_date: minStartDate.format('YYYY-MM-DD'),
        });
      }
      // Otherwise just update end date
      else {
        this.setState({ end_date: value });
      }
    }
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e.value });
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getProfitMargin();
    });
  };

  resetFilter = () => {
    this.limitInput.current.value = 20;
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        loading: false,
        product_id: '',
        bank_id: '',
        limit: 20,
        offset: 1,
      },
      function () {
        //this.getProfitMargin();
      },
    );
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getProfitMargin();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true, offset: 1 }, function () {
      this.getProfitMargin();
    });
  };
  render() {
    const { profitList } = this.state;
    return (
      <section className="widget full-width list-table inverted">
        <header>
          <h3>Profit Margin Report</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group">
                <label>Date range:</label>
                <DateRangeFilter
                  value={[this.state.start_date, this.state.end_date]}
                  onChange={(dates) => {
                    this.setState({
                      start_date: dates[0],
                      end_date: dates[1],
                    });
                  }}
                  limit={6}
                />
              </div>
              <div className="filter-group">
                <label> Fuel type:</label>
                <FuelList
                  onChange={this.handleProductChange}
                  value={this.state.product_id}
                />
              </div>
              <div className="filter-group with-icon">
                <label>
                  Results to display- {this.state.limit || 20} (Total:{' '}
                  {this.state.count})
                </label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  ></button>
                </form>
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="filter-group">
                <button
                  className={`submit ${this.state.loading ? 'loading' : ''}`}
                  disabled={this.state.loading}
                  type="submit"
                  onClick={this.submitForm}
                >
                  Generate Report
                </button>
              </div>
            </div>
          </div>
          <div className="table-wrapper">
            <div className="mini-summary">
              <ul>
                <li>
                  <span> Total: </span>
                  <span>
                    {new Intl.NumberFormat('en-IN', {}).format(
                      profitList
                        .reduce((a, b) => a + (b['profit'] || 0), 0)
                        .toFixed(2) || 0,
                    )}
                  </span>
                </li>
              </ul>
            </div>
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <TableGrid
                    col={col}
                    row={profitList}
                    offset={this.state.offset}
                    count={this.state.count}
                    limit={this.state.limit}
                    handlePagination={this.handlePagination}
                    hideActions={true}
                    exportOptions={{
                      fileName: `Profit Margin - ${this.state.start_date} to ${this.state.end_date}.pdf`,
                      reportName: 'Profit margin Report',
                      reportDate: `Date - ${dayjs(this.state.start_date).format('D MMM YY')} to ${dayjs(this.state.end_date).format('D MMM YY')}`,
                      reportTotal: `Total  -  ${
                        profitList
                          .reduce((a, b) => a + (b['profit'] || 0), 0)
                          .toFixed(2) || 0
                      }`,
                      reportQuantity: '',
                      reportSales: '',
                      reportTesting: '',
                      reportBowser: '',
                      reportCustomerName: '',
                      reportGst: '',
                      reportOpeningBalance: '',
                      reportClosingBalance: '',
                      reportSaleTotal: '',
                      reportTCSTotal: '',
                    }}
                  />
                );
              }
            })()}
          </div>
        </main>
      </section>
    );
  }
}

export { ProfitMargin };
